import { Check, Trash2, Plus, Lock, UserX } from "lucide-react";
import { semCadastro } from "../hooks";
import Loading from "../../../../components/loading";
import CustomPagination from "../../../../components/paginate";
import libFloat from "../../../../util/libFloat";
import LibDateTime from "../../../../util/libDateTime";

export default function TabelaBusca({
	resultado,
	pagina,
	totalPaginas,
	carregando,
	buscou,
	onBuscar,
	onAdicionar,
	onRemover,
	jaSelecionada,
	jaEmitidos,
}) {
	const handleChangePage = (event, novaPagina) => {
		if (novaPagina >= 1) onBuscar(novaPagina);
	};

	return (
		<div className="flex-1 flex flex-col min-h-0 border rounded-md bg-white border-gray-300 overflow-hidden">
			<div className="flex-1 overflow-y-auto">
				<table className="table table-portal mb-0 w-full border-b">
					<thead className="color-table sticky top-0 z-10 shadow-sm">
						<tr>
							<th className="text-left font-semibold py-2 border-b">
								<span className="text-color-table">Cliente</span>
							</th>
							<th className="text-center font-semibold py-2 border-b w-24">
								<span className="text-color-table">Venda</span>
							</th>
							<th className="text-center font-semibold py-2 border-b w-24">
								<span className="text-color-table">Parcela</span>
							</th>
							<th className="text-center font-semibold py-2 border-b w-32">
								<span className="text-color-table">Vencimento</span>
							</th>
							<th className="text-right font-semibold py-2 border-b w-32">
								<span className="text-color-table">Valor</span>
							</th>
							<th className="text-center font-semibold py-2 border-b w-52">
								<span className="text-color-table">Ação</span>
							</th>
						</tr>
					</thead>

					<tbody>
						{resultado.map((item) => {
							const selecionada = jaSelecionada(item.id_conta_entrada);
							// Ja tem boleto: a linha nao entra em remessa nova.
							const emitido = jaEmitidos?.[item.id_conta_entrada];
							const generico = semCadastro(item);
							const bloqueada = Boolean(emitido) || generico;

							return (
								<tr
									key={item.id_conta_entrada}
									className={
										bloqueada
											? "opacity-60 bg-gray-50"
											: "hover:bg-customBlue-primary/5 group cursor-pointer"
									}
									onClick={() => !bloqueada && !selecionada && onAdicionar(item)}
								>
									<td className="text-left align-middle font-medium py-2">{item.nome}</td>
									<td className="text-center align-middle text-gray-500 text-sm">
										{item.id_venda}
									</td>
									<td className="text-center align-middle text-gray-500 text-sm">
										{item.parcela}/{item.parcela_total}
									</td>
									<td className="text-center align-middle">
										{LibDateTime.parseDelphiLocal(item.data, "dd/MM/yyyy")}
									</td>
									<td className="text-right align-middle text-emerald-600 font-semibold">
										{libFloat.strToCurrency(item.valor)}
									</td>
									<td className="text-center align-middle">
										{generico ? (
											<span
												title="Pedido feito por visitante, sem cadastro."
												className="inline-flex items-center justify-center gap-1 text-xs text-amber-700 font-medium"
											>
												<UserX size={12} className="shrink-0" />
												Sem cadastro — boleto exige CPF
											</span>
										) : bloqueada ? (
											// Mostra o motivo, nao so a proibicao.
											// O numero da remessa diz em qual arquivo
											// esta parcela foi - e o que permite achar
											// o .rem depois.
											<span
												title={`Boleto ${emitido.nossoNumero} · Remessa ${emitido.numeroRemessa}`}
												className="inline-flex flex-col items-center gap-0.5 leading-tight"
											>
												<span className="inline-flex items-center gap-1 font-mono text-xs text-gray-600">
													<Lock size={12} className="shrink-0" />
													{emitido.nossoNumero}
												</span>
												<span className="px-2 py-0.5 rounded-full bg-gray-200 text-gray-600 text-[10px] font-medium">
													Remessa {emitido.numeroRemessa}
												</span>
											</span>
										) : selecionada ? (
											// Mesmo padrao do vinculo de produtos: verde
											// confirmando, lixeira vermelha ao passar o
											// mouse - remove sem trocar de aba.
											<button
												type="button"
												title="Já está na remessa. Clique para remover."
												className="btn btn-sm btn-success p-1 rounded flex items-center justify-center hover:bg-red-500 hover:border-red-500 transition-colors group/btn w-7 h-7 mx-auto"
												onClick={(e) => {
													e.stopPropagation();
													onRemover(item.id_conta_entrada);
												}}
											>
												<span className="block group-hover/btn:hidden">
													<Check size={16} />
												</span>
												<span className="hidden group-hover/btn:block text-white">
													<Trash2 size={16} />
												</span>
											</button>
										) : (
											<button
												type="button"
												title="Adicionar à remessa"
												className="btn btn-sm btn-outline-primary p-1 rounded opacity-70 group-hover:opacity-100 transition-opacity"
												onClick={(e) => {
													e.stopPropagation();
													onAdicionar(item);
												}}
											>
												<Plus size={16} />
											</button>
										)}
									</td>
								</tr>
							);
						})}

						{resultado.length === 0 && !carregando && (
							<tr>
								<td colSpan={6} className="text-center text-gray-400 py-10">
									{buscou
										? "Nenhuma parcela encontrada no período."
										: "Escolha o período e clique em Buscar."}
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>

			{carregando && (
				<div className="flex h-44">
					<Loading mensagem="Buscando parcelas..." />
				</div>
			)}

			{buscou && !carregando && (
				<CustomPagination
					page={pagina}
					onChangePage={handleChangePage}
					data={resultado}
					totalPage={totalPaginas}
					totalRecord={resultado.length}
				/>
			)}
		</div>
	);
}
